import { ONBOARDING_PAGE } from 'global/routes';

export const RIBOnboardingRoutes = {
  SAFEST_TOWNHOUSE: `${ONBOARDING_PAGE}/safest-townhouse`,
  SIMPLER_EVERYDAY: `${ONBOARDING_PAGE}/simpler-everyday`,
  ORDINARY_HOUSE_BUT_SAFER: `${ONBOARDING_PAGE}/ordinary-house-but-safer`,
  YOUR_INFO: `${ONBOARDING_PAGE}/your-info`,
};

